// event-bus.js
import Vue from 'vue';


const ModalEventBus = new Vue();
export default ModalEventBus;




//listen on event fired - you could use this to log or debug the total system..
ModalEventBus.$on('show-modal', (payload: any) => {
    console.log('something is happening..');
});


ModalEventBus.$on('custom-component-wrapper-add', (payload: any) => {
    console.log('something is happening..');
});


//standard model for the modal
export interface IModal{
    currentComponent: any;
    type: string; //TODO: - create ENUM type..
    header: string;
    message: string;
    onChange: Function; //callback on changes
    success: Function; //callback
    error: Function; //callback
    close: Function; //callback
}


